import { NonEmployeeList } from "components/non-employee/employee-list/NonEmployeeList";
import { getStatus } from "configs/non-employee/configTableEmployeeList";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useSearchParams } from "react-router-dom";
import { API_NON_EMPLOYEE } from "services/apiNonEmployee";
import { useFetch } from "services/useFetch";
import { setToast } from "../../../reducers/employeeListReducer";
import { downloadFile, getAllQueryParams, setQueryParams } from "../../../utils/utils";


const FILTER_PARAMS = ['department_ids', 'division_ids', 'subdivision_ids', 'status', 'type', 'start_date', 'end_date']

const TAB_LIST = [
    {id: 'registered', name: 'registered'},
    {id: 'active', name: 'active'},
    {id: 'inactive', name: 'inactive'},
]

export const NonEmployeeListContainer = () => {
    const location = useLocation()
    const defaultQuery = {
        page: 1,
        search: '',
        limit: 20,
    }
    const dispatch = useDispatch()
    const {toast} = useSelector((state) => state.employeeListReducer)
    const [searchParams, setSearchParams] = useSearchParams();
    const query = searchParams.size > 0 ? getAllQueryParams(searchParams) : defaultQuery
    const {data: employeeData, fetching: getEmployeeListApi} = useFetch(API_NON_EMPLOYEE.LIST_EMPLOYEE, {})
    const [selectedIds, setSelectedIds] = useState([])
    const {fetching: exportEmployeeApi} = useFetch(API_NON_EMPLOYEE.EXPORT_EMPLOYEE, {})
    const {fetching: deleteEmployeeApi} = useFetch(API_NON_EMPLOYEE.DELETE_EMPLOYEE, {})
    const [modal, setModal] = useState({
        sort: false,
        delete: false,
        export: false,
        filter: false,
        alert: false
    })
    const [alert, setAlert] = useState({title: '', description: ''})
    const [queryFilter, setQueryFilter] = useState()
    const [bodyRequest, setBodyRequest] = useState(defaultQuery)
    const tab = searchParams.get('tab')

    useEffect(() => {
        const newQuery = {...query}
        const newQueryFilter = {}
        Object.entries(newQuery).forEach(([key, item]) => {
            if (FILTER_PARAMS.includes(key)) {
                const valueOfQuery = FILTER_PARAMS.slice(0, 5).includes(key) ? item.split(',') : item
                newQuery[key] = valueOfQuery
                newQueryFilter[key] = valueOfQuery
            }
        })

        const body = {
            ...bodyRequest,
            status: newQuery?.status ? newQuery.status : newQuery.tab ? getStatus[newQuery.tab] : getStatus['registered'],
            type: newQuery?.type || [],
            department_ids: newQuery.department_ids || [],
            division_ids: newQuery.division_ids || [],
            subdivision_ids: newQuery.subdivision_ids || [],
            start_join_date: newQuery.start_date || null,
            end_join_date: newQuery.end_date || null,
            order_by: newQuery?.order_by || 'created_at',
            order_type: newQuery?.order_type || 'desc',
            limit: newQuery.limit,
            search: newQuery.search || '',
            page: newQuery.page
        }

        setQueryFilter(newQueryFilter)
        setBodyRequest(body)
        getEmployee(body)
    }, [location.search])

    const getEmployee = (body) => {
        getEmployeeListApi(body)
            .catch(err => console.log("err :", err))
    }

    const onSelectHandler = (item) => {
        let ids = item?.map(i => i?.id)
        setSelectedIds(ids)
    }

    const onAddEmployeeHandler = () => {
        window.open('/non-employee-worker/add-non-employee', '_blank', 'noopener,noreferrer')
    }

    const importEmployeeHandler = () => {
        window.open('/non-employee-worker/import-non-employee', '_blank', 'noopener,noreferrer')
    }

    const onExportHandler = () => {
        let body = {...bodyRequest, employee_ids: selectedIds}

        exportEmployeeApi(body, '', {}, 'blob')
            .then(res => {
                downloadFile(null, res, `Non-Employee-List-Export-${moment().format('DD-MM-YYYY')}.xlsx`)
                setModal({...modal, export: false})
                dispatch(setToast({isShowToast: true, message: 'Export Data Berhasil !!'}))
            })
    }

    const onDeleteEmployee = () => {
        deleteEmployeeApi({employee_ids: selectedIds})
            .then(resp => {
                let failedData = []
                resp?.data?.map(data => !data?.isSuccess && failedData.push(data))

                if (!failedData?.length) {
                    if (Number(query?.page) !== 1) {   
                        onChangeQuery({page: 1})
                    } else {
                        getEmployee({...bodyRequest})
                    }
                    setAlert({title: 'Success', description: 'Data berhasil dihapus !'})
                    setModal({...modal, delete: false, alert: true})
                } else {
                    setAlert({title: 'Delete Failed', description: 'Data tidak dapat dihapus !'})
                    setModal({...modal, delete: false, alert: true})
                }
            })
    }

    const onClickButtonDelete = () => {
        if (!selectedIds?.length) {
            setAlert({title: 'Delete Failed', description: 'Silahkan pilih nama karyawan untuk dihapus!'})
            setModal({...modal, alert: true})
        } else {
            setModal({...modal, delete: true})
        }
    }

    const setModalVisibility = (modalVisibility) => {
        setModal({...modal, ...modalVisibility})
    }

    const onChangeQuery = (queryParams) => {
        const params = setQueryParams({...query, ...queryParams})
        setSearchParams(params, {replace: true})
    }

    const onChangeTab = (tab) => {
        onChangeQuery({page: 1, status: null, tab: tab.id})
    }

    const clearToast = () => {
        dispatch(setToast({isShowToast: false, message: ''}))
    }

    const props = {
        tabList: TAB_LIST,
        alert,
        modal,
        toast,
        selectedIds,
        employeeData,
        tab: tab || TAB_LIST[0].id,
        onClickButtonDelete,
        onImportEmployee: importEmployeeHandler,
        onAddEmployee: onAddEmployeeHandler,
        onDeleteEmployee,
        onExportHandler,
        setModalVisibility,
        onSelectHandler,
        isLoading: employeeData?.isLoading,
        onChangeQuery,
        query,
        queryFilter,
        onSubmitFilter: (queryFilter) => onChangeQuery(queryFilter),
        onClickSort: (queryFilter) => onChangeQuery(queryFilter),
        clearToast,
        onChangeTab,

    }

    return <NonEmployeeList {...props}/>
}
